import {
  ProductDetailDTO,
  ProductSubType,
  TrainerProgramApproval,
} from "@campgladiator/cg-common.types.types";

export const getProgramApprovedType: {
  [key: string]: TrainerProgramApproval;
} = {
  BOOTCAMP_ONLINE: "onlineApproved",
  BOOTCAMP_IN_PERSON: "outdoorApproved",
  STRENGTH_IN_PERSON: "strengthApproved",
  NUTRITION_ONLINE: "nutritionApproved",
};

export const getProgramApprovedTypeBySelectedProductDetail = (
  productDetails: ProductDetailDTO
) => {
  const approvedType =
    getProgramApprovedType[
      `${productDetails?.type}_${productDetails?.subType}`
    ];

  const outdoorApprovedIfOnline =
    (productDetails?.subType as ProductSubType) === "ONLINE"
      ? getProgramApprovedType["BOOTCAMP_IN_PERSON"]
      : undefined;

  const onlineApprovedIfOutdoor =
    (productDetails?.subType as ProductSubType) === "IN_PERSON"
      ? getProgramApprovedType["BOOTCAMP_ONLINE"]
      : undefined;
  return {
    approvedType,
    outdoorApprovedIfOnline,
    onlineApprovedIfOutdoor,
  };
};
